import styled from '@emotion/styled';
import {sizes} from 'patient-ping-remedy/packages/theme';
import {DisplaySmallTypography} from 'patient-ping-remedy/packages/typography';

export const Header = styled(DisplaySmallTypography)`
  display: block;
  margin-block: ${sizes.medium};
`;

export const Contacts = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${sizes.xSmall};
`;

export const GroupContext = styled.div`
  margin-block: ${sizes.small};
`;
